import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navigation: "CaseStudies"
  },
  mutations: {
    NAV_ABOUT(state) {
      state.navigation = "About";
    },
    NAV_CASE(state) {
      state.navigation = "CaseStudies";
    },
    NAV_CONTACT(state) {
      state.navigation = "Contact";
    }
  },
  actions: {}
});
